import {
  CheckCircle,
  ProcessArrow,
  LandlordRelatedInformation,
  CheckCircleSuccess,
  ArrowRight,
} from 'common/components/svgs';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Select } from 'antd';
import Modal from 'common/components/modal';
import { CloseCircleOutlined } from '@ant-design/icons';
import { MUTATION_DS_UpdateLandlord_ListingPlan } from '../queries';
import { upperCase } from 'lodash';
import { useMutation } from '@apollo/client';

const uesStyles = makeStyles(
  theme => ({
    wrapper: {
      '& .ant-modal-header': {
        padding: '32px 32px 24px 32px',
      },
      '& .ant-modal-body': {
        padding: '0 32px',
      },

      '& .ant-form-item-label': {
        lineHeight: '22px',
        marginBottom: 8,
      },
    },
    p16_24: {
      padding: '16px 24px',
    },
    layout: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: 'white',
      padding: '40px 0',
    },
    arrow: {
      width: '24px',
      height: '12px',
      margin: '0 16px',
      transform: 'rotate(90deg)',
      fill: theme.colors.yellow6,
    },
    selector: {
      '& .ant-select-selection--single': {
        height: '54px !important',
      },
    },
    h5: {
      fontSize: '14px',
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '22px',
    },
    layerBox: {
      display: 'flex',
      border: '1px solid #0000000F',

      borderRadius: '2px',
      margin: '8px 0 32px 0',
      '& > div': {
        flex: 1,
        '&:first-child': {
          background: 'white',
          padding: '24px 32px',
        },
        '&:last-child': {
          background: '#FAFAFA',
          padding: '24px 32px',
        },
      },
    },

    planBox: {
      borderRadius: '2px',
      background: 'rgba(245, 245, 245, 1)',
      display: 'flex',
      alignItems: 'center',
      padding: '12px 24px',
      marginTop: '24px',
    },
    img: {
      width: '320px',
      height: '200px',
    },
    bodyRegular: {
      fontSize: '14px',
      fontWeight: 400,
      color: 'rgba(0, 0, 0, 0.65)',
      lineHeight: '22px',
    },

    small: {
      fontSize: '12px',
      fontWeight: 400,
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '20px',
    },
    description_title: {
      fontSize: '12px',
      marginTop: '16px',
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '22px',
    },
    description_line: {
      display: 'flex',
      fontSize: '12px',
      fontWeight: 400,
      marginTop: '8px',
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '20px',
    },
  }),
  { name: 'SignmeUp-Dialog' },
);
const { Option } = Select;

const ConfirmChange = ({ setOpen, open, changeType, type, callback, landlordId }) => {
  const classes = uesStyles();
  const [updateLandlordListingPlan, { loading: updateLoading }] = useMutation(
    MUTATION_DS_UpdateLandlord_ListingPlan,
    {
      variables: {
        input: {
          id: landlordId,
          listingPlan: upperCase(changeType),
        },
      },
      onCompleted: () => {
        callback && callback('success');
      },
      onError: error => {
        console.log('[updateLandlordListingPlan  -> error ] >', error);
        callback && callback('success');
      },
    },
  );

  return (
    <Modal
      width={456}
      visible={open}
      okText={'Yes, I’m sure'}
      wrapClassName={classes.wrapper}
      onCancel={() => {
        setOpen(false);
      }}
      onOk={async () => {
        updateLandlordListingPlan();
      }}
      okButtonProps={{
        loading: updateLoading,
      }}
      destroyOnClose={true}
    >
      <div style={{ padding: '32px 0' }}>
        <div className={classes.h5}>Are you sure to make this change?</div>
        <div
          className={classes.p16_24}
          style={{ display: 'flex', marginTop: '16px', background: '#FAFAFA' }}
        >
          <LandlordRelatedInformation style={{ width: '48px', height: '48px' }} />
          <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '16px' }}>
            <div className={classes.bodyRegular} style={{ color: '#00000073' }}>
              Listing Plan:
            </div>

            <div
              className={classes.bodyRegular}
              style={{ display: 'flex', alignItems: 'center', marginTop: '4px' }}
            >
              {type}
              <ArrowRight width={10} height={10} style={{ flexShrink: 0, margin: '0 8px' }} />
              <CheckCircleSuccess
                style={{
                  width: '14px',
                  fill: '#38B2A6',
                  flexShrink: 0,
                  height: '14px',
                  marginRight: '8px',
                }}
              />
              <div style={{ fontWeight: 600 }}>{changeType}</div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

function Index({ setOpen, open, data, type, landlordId, callback }) {
  const classes = uesStyles();

  const [currentPlan, setCurrentPlan] = React.useState(data.filter(d => d.title === type)[0]);

  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const getCheckIcon = icon_status =>
    icon_status === 'enabled' ? (
      <CheckCircle
        style={{
          width: '14px',
          flexShrink: 0,
          height: '14px',
          margin: '3px 6px 0 0',
          color: '#38b2a6',
        }}
      />
    ) : (
      <CloseCircleOutlined
        style={{
          width: '14px',
          flexShrink: 0,
          height: '14px',
          margin: '3px 6px 0 0',
          color: 'rgba(191, 191, 191, 1)',
        }}
      />
    );
  return (
    <Modal
      width={820}
      visible={open}
      title={'Edit Listing Plan'}
      okText={'Confirm'}
      wrapClassName={classes.wrapper}
      onCancel={() => {
        setOpen(false);
      }}
      onOk={() => {
        setConfirmOpen(true);
      }}
      okButtonProps={{
        loading: false,
      }}
      destroyOnClose={true}
    >
      <div>
        <div className="">Listing Plan</div>
        <Select
          defaultValue={type}
          className={classes.selector}
          style={{ width: '100%', minHeight: '52px' }}
          onChange={value => {
            setCurrentPlan(data.filter(item => item.title === value)[0]);
          }}
        >
          {data.map((d, idx) => (
            <Option value={d.title} key={idx}>
              <div>
                <div>{d.title}</div>
                <div className={classes.small} style={{ color: 'rgba(0,0,0,.45)' }}>
                  {d.description}
                </div>
              </div>
            </Option>
          ))}
        </Select>
        <div className={classes.layerBox}>
          <div>
            <div className={classes.h5} style={{ color: '#00000040' }}>
              Student Experience
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {currentPlan.student_experience.map((se, idx) => (
                <>
                  <div
                    key={idx}
                    style={{
                      padding: '24px 32px',
                      // minHeight: '200px',
                      width: '340px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      <div
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          backgroundColor: 'rgba(252, 206, 1, 0.2)',
                        }}
                      >
                        {React.cloneElement(se.icon.icon, {
                          style: { width: '22px', height: '22px' },
                        })}
                      </div>
                      <dv
                        className={classes.smallRegular}
                        style={{
                          marginTop: '16px',
                          textAlign: 'center',
                          fontSize: '12px',
                          lineHeight: '20px',
                        }}
                      >
                        {se.action}
                      </dv>
                    </div>
                  </div>
                  {idx !== 2 && <ProcessArrow className={classes.arrow} />}
                </>
              ))}
            </div>
          </div>
          <div>
            <div className={classes.h5} style={{ color: '#00000040' }}>
              Landlord Experience
            </div>
            <div>
              {currentPlan.landlord_experience.map((item, index) => (
                <div key={`items_${index}`}>
                  <div className={classes.description_title}>{item.title}</div>
                  {item.content.map((ct, idx) => (
                    <div key={idx} className={classes.description_line}>
                      {getCheckIcon(ct?.icon_status)}
                      <div>{ct.description}</div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
        <ConfirmChange
          setOpen={status => {
            setConfirmOpen(status);
          }}
          landlordId={landlordId}
          type={type}
          changeType={currentPlan.title}
          open={confirmOpen}
          callback={result => {
            if (result === 'success') {
              setConfirmOpen(false);
              setOpen(false);
              callback && callback(currentPlan.title);
            }
          }}
        />
      </div>
    </Modal>
  );
}

export default Index;
